import MainApi from "../../api/MainApi";

const API = new MainApi();
export const BASE_PATH_URL_PACKAGE_BOX = `${API._baseIfurn}/vendor/box3d/api.html`